// extracted by mini-css-extract-plugin
export default {"container":"AdminUpdateBlog_container__wgZvY","content":"AdminUpdateBlog_content__2UUYj"};